import { useStore } from 'vuex';
import { getUserData } from './api';

export async function updateStoreData() {
    const store = useStore();
    const role = store.state.role
    const email_verified = store.state.email_verified
    const discord_verified = store.state.discord_verified
    const credits = store.state.credits
    const server_slots = store.state.server_slots
    const server_count = store.state.server_count
    const name = store.state.name

    if (role === null || email_verified === null || discord_verified === null || credits === null || server_slots === null || server_count === null || name === null) {
        const result = await getUserData();
        if (!result.success) {
            return false
        } else {
            store.dispatch('updateData', {
                role: result.role,
                email_verified: result.email_verified,
                discord_verified: result.discord_verified,
                credits: result.credits,
                server_slots: result.server_slots,
                server_count: result.server_count,
                name: result.name
            });
            return true
        }
    }else {
        return true
    }
}